export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  category: string;
  genre: string;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  description: string;
  longDescription: string;
  posterSeq: string;
  posterWidth: number;
  posterHeight: number;
  isNew: boolean;
  isHot: boolean;
  updateDate: string;
  tags: string[];
}

export const allMovies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    year: 2026,
    category: 'movie',
    genre: '科幻',
    rating: 9.2,
    duration: '148分钟',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出，展开争分夺秒的生死之战。',
    longDescription: '在不远的未来，太阳急速衰老膨胀，地球面临被吞没的危机。为求生存，人类开启"流浪地球"计划，倾全球之力在地球表面建造上万座发动机和转向发动机，推动地球离开太阳系，奔向4.2光年外的新家园。在这场跨越2500年的漫长宇宙之旅中，人类文明面临着前所未有的考验与抉择。年轻的航天员们肩负起拯救人类的使命，在浩瀚太空中与时间赛跑，与命运抗争。',
    posterSeq: 'movie-poster-01',
    posterWidth: 400,
    posterHeight: 560,
    isNew: true,
    isHot: true,
    updateDate: '2026-07-28',
    tags: ['IMAX', '3D', '国产科幻', '高评分'],
  },
  {
    id: 'movie-2',
    title: '封神第二部：战火西岐',
    titleEn: 'Creation of the Gods II',
    year: 2026,
    category: 'movie',
    genre: '奇幻',
    rating: 8.8,
    duration: '152分钟',
    director: '乌尔善',
    cast: ['费翔', '黄渤', '于适', '陈牧驰', '娜然'],
    description: '姜子牙携封神榜下凡，西岐与朝歌两大阵营正式开战。各方神仙妖魔纷纷登场，一场关乎天下苍生命运的大战拉开帷幕。',
    longDescription: '商王殷寿暴虐无道，天怒人怨。姜子牙携封神榜下凡，寻找天下共主。西岐少主姬发在姜子牙的辅佐下，联合各路诸侯，举起反抗大旗。朝歌与西岐两大阵营正式开战，雷震子、哪吒、杨戬等神话人物悉数登场，一场神仙打架的史诗大战就此展开。影片以宏大的东方奇幻美学，重新诠释了中国古典神话的壮丽画卷。',
    posterSeq: 'movie-poster-02',
    posterWidth: 400,
    posterHeight: 560,
    isNew: true,
    isHot: true,
    updateDate: '2026-07-20',
    tags: ['IMAX', '神话史诗', '视觉盛宴'],
  },
  {
    id: 'movie-3',
    title: '哪吒之魔童闹海',
    titleEn: 'Nezha: The Demon Child Reborn',
    year: 2025,
    category: 'movie',
    genre: '动画',
    rating: 9.5,
    duration: '128分钟',
    director: '饺子',
    cast: ['吕艳婷', '瀚墨', '陈浩', '绿绮'],
    description: '天劫之后，哪吒和敖丙虽保住了灵魂，但肉身濒临消散。太乙真人欲用七色宝莲为二人重塑肉身，一场更大的危机却悄然降临。',
    longDescription: '经历天劫之后，哪吒和敖丙的灵魂虽得以保存，但肉身即将消散。太乙真人欲用七色宝莲为二人重塑肉身，却遭遇重重阻碍。与此同时，四海龙王联手复仇，一场更大的危机席卷陈塘关。哪吒必须在重塑肉身和守护家园之间做出抉择。这部动画以精湛的视觉效果和深刻的情感内核，再次证明了中国动画的无限可能。',
    posterSeq: 'movie-poster-03',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: true,
    updateDate: '2025-02-10',
    tags: ['动画', '国漫之光', '票房冠军'],
  },
  {
    id: 'movie-4',
    title: '热辣滚烫',
    titleEn: 'YOLO',
    year: 2024,
    category: 'movie',
    genre: '喜剧',
    rating: 8.5,
    duration: '129分钟',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    description: '善良的乐莹在经历一系列挫折后，决定通过拳击改变自己。这是一个关于自我救赎和蜕变的热血故事。',
    longDescription: '乐莹是一个善良、柔软的姑娘，却总被生活无情地打击。在遭遇了事业、爱情、亲情的多重挫折后，她偶然接触到了拳击运动。从此，她的人生发生了翻天覆地的变化。在拳击台上，她找到了久违的自我，也找到了对抗世界的勇气。这是一部笑中带泪的励志喜剧，讲述了一个普通女孩不平凡的蜕变之旅。',
    posterSeq: 'movie-poster-04',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: true,
    updateDate: '2024-02-10',
    tags: ['喜剧', '励志', '女性题材'],
  },
  {
    id: 'movie-5',
    title: '消失的她',
    titleEn: 'Lost in the Stars',
    year: 2023,
    category: 'movie',
    genre: '悬疑',
    rating: 8.7,
    duration: '122分钟',
    director: '崔睿',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    description: '妻子在海外旅行中神秘失踪，丈夫疯狂寻找。当妻子再次出现时，丈夫却坚称她不是自己的妻子，一场惊天阴谋浮出水面。',
    longDescription: '何非和妻子李木子去东南亚旅行，庆祝结婚周年。然而，妻子在一夜之间神秘失踪。何非四处寻找无果，就在他几近崩溃之际，一个自称是他妻子的女人突然出现。但何非坚持，这个女人不是他的妻子。是精神错乱，还是有人设下惊天陷阱？随着金牌律师陈麦的介入调查，真相越来越扑朔迷离。',
    posterSeq: 'movie-poster-05',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2023-06-22',
    tags: ['悬疑', '烧脑', '反转'],
  },
  {
    id: 'movie-6',
    title: '孤注一掷',
    titleEn: 'No More Bets',
    year: 2023,
    category: 'movie',
    genre: '犯罪',
    rating: 8.6,
    duration: '135分钟',
    director: '申奥',
    cast: ['张艺兴', '金晨', '王传君', '周也'],
    description: '程序员潘生和模特安娜被高薪工作诱惑到海外，却落入诈骗工厂的陷阱。他们在绝望中寻找逃脱的机会。',
    longDescription: '程序员潘生和模特安娜，被海外高薪招聘吸引，满怀憧憬地来到东南亚。然而等待他们的不是美好前程，而是一座充满暴力和欺骗的诈骗工厂。在这里，他们被剥夺自由，被迫参与网络诈骗。面对残酷的现实，他们不得不想尽一切办法逃离这个人间地狱。影片大胆揭露了境外网络诈骗的黑暗产业链，引发深刻社会思考。',
    posterSeq: 'movie-poster-06',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2023-08-08',
    tags: ['犯罪', '社会题材', '真实事件改编'],
  },
  {
    id: 'movie-7',
    title: '满江红',
    titleEn: 'Full River Red',
    year: 2023,
    category: 'movie',
    genre: '历史',
    rating: 8.4,
    duration: '159分钟',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇凶案揭开层层迷雾，小兵张大与亲兵营副统领孙均被迫卷入其中。',
    longDescription: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这场巨大的阴谋之中。宰相秦桧命两人在有限时间内找到凶手。随着调查深入，真相渐渐浮出水面，而背后的故事远比想象中更加惊心动魄。',
    posterSeq: 'movie-poster-07',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2023-01-22',
    tags: ['历史', '悬疑', '喜剧'],
  },
  {
    id: 'movie-8',
    title: '长津湖',
    titleEn: 'The Battle at Lake Changjin',
    year: 2021,
    category: 'movie',
    genre: '战争',
    rating: 9.0,
    duration: '176分钟',
    director: '陈凯歌',
    cast: ['吴京', '易烊千玺', '段奕宏', '朱亚文', '李晨'],
    description: '1950年，中国志愿军部队在极度严酷的环境下，东线作战部队凭着钢铁意志和英勇无畏的战斗精神，扭转了战场态势，打出了军威国威。',
    longDescription: '1950年，中国志愿军第九兵团在长津湖地区与美军展开了一场惨烈的战役。在零下四十度的极寒天气中，志愿军战士们以冻土豆充饥，用血肉之躯筑起钢铁长城。他们克服了装备悬殊、补给不足等重重困难，以惊人的意志力和无畏的牺牲精神，创造了抗美援朝战争中全歼美军一个整团的纪录，为最终的胜利奠定了坚实基础。',
    posterSeq: 'movie-poster-08',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2021-09-30',
    tags: ['战争', '历史', '爱国主义'],
  },
  {
    id: 'movie-9',
    title: '你好，李焕英',
    titleEn: 'Hi, Mom',
    year: 2021,
    category: 'movie',
    genre: '喜剧',
    rating: 8.9,
    duration: '128分钟',
    director: '贾玲',
    cast: ['贾玲', '张小斐', '沈腾', '陈赫'],
    description: '2001年，刚考上大学的贾晓玲意外穿越到1981年，与年轻时的母亲李焕英相遇。她决定用自己的方式让母亲过上更好的生活。',
    longDescription: '刚考上大学的贾晓玲，在经历人生的大起大落后，意外穿越回到了1981年，与正值青春的母亲李焕英相遇。为了让母亲"更幸福"，贾晓玲想尽各种办法撮合母亲和厂长儿子的姻缘。在这一过程中，她重新认识了母亲，也体会到了母爱的伟大。影片以温暖幽默的方式讲述了一个关于亲情与遗憾的动人故事。',
    posterSeq: 'movie-poster-09',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2021-02-12',
    tags: ['喜剧', '亲情', '感人'],
  },
  {
    id: 'movie-10',
    title: '独行月球',
    titleEn: 'Moon Man',
    year: 2022,
    category: 'movie',
    genre: '科幻',
    rating: 8.3,
    duration: '122分钟',
    director: '张吃鱼',
    cast: ['沈腾', '马丽', '常远', '黄才伦'],
    description: '人类为抵御小行星撞击，部署了月盾计划。维修工独孤月因意外错过撤离，被留在月球上，开始了他在月球上的独居生活。',
    longDescription: '人类为抵御小行星的撞击，部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因为意外错过了领队马蓝星的撤离通知，一个人落在了月球。不料月盾计划失败，独孤月成了"宇宙最后的人类"，开始了他在月球上破罐子破摔的生活。然而，他并不知道，自己的一举一动正在被全球直播。',
    posterSeq: 'movie-poster-10',
    posterWidth: 400,
    posterHeight: 560,
    isNew: false,
    isHot: false,
    updateDate: '2022-07-29',
    tags: ['科幻', '喜剧', '沈腾'],
  },
];

export const movieGenres = ['全部', '科幻', '奇幻', '动画', '喜剧', '悬疑', '犯罪', '历史', '战争', '剧情', '动作', '爱情'];

export const getMoviesByGenre = (genre: string): Movie[] => {
  if (genre === '全部') return allMovies;
  return allMovies.filter((m) => m.genre === genre);
};

export const getMovieById = (id: string): Movie | undefined => {
  return allMovies.find((m) => m.id === id);
};

export const getLatestMovies = (count: number = 8): Movie[] => {
  return [...allMovies].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, count);
};

export const getHotMovies = (count: number = 8): Movie[] => {
  return [...allMovies].filter((m) => m.isHot).sort((a, b) => b.rating - a.rating).slice(0, count);
};